module.exports = __webpack_public_path__ + "img/campanha-vendas-2026-cartaz-horizontal.bdba9699.jpeg";